<template>
  <CommonFramework :name="'修改账号密码'">
    <pop-panel>
      <a-form
        :form="form"
        @submit="save"
        class="pop-common-form"
        :style="{ width: '820px', margin: '0 auto' }"
      >
        <a-form-item class="form-item" label="账号" v-bind="formItemLayout">
          <Input v-model="$route.query.account" disabled />
        </a-form-item>
        <a-form-item
          class="form-item"
          v-bind="formItemLayout"
          :validate-status="form.originalPassword.validateStatus"
          :help="form.originalPassword.help"
          hasFeedback
        >
          <template slot="label">
            <span class="required">原密码</span>
          </template>
          <Input
            type="password"
            placeholder="请输入密码"
            v-model="form.originalPassword.value"
            @change="validateHandler('originalPassword', $event)"
          />
        </a-form-item>
        <a-form-item
          class="form-item"
          v-bind="formItemLayout"
          :validate-status="form.newPassword.validateStatus"
          :help="form.newPassword.help"
          hasFeedback
        >
          <template slot="label">
            <span class="required">新密码</span>
          </template>
          <Input
            type="password"
            placeholder="请输入密码"
            v-model="form.newPassword.value"
            @change="validateHandler('newPassword', $event)"
          />
          <span
            class="iconTip"
            v-show="!form.newPassword.value && !form.newPassword.validateStatus"
            ><img src="../../assets/images/icon-tip.jpg" /><span>{{
              this.pwdValidMsg
            }}</span></span
          >
        </a-form-item>
        <a-form-item
          class="form-item"
          v-bind="formItemLayout"
          :validate-status="form.confirmNewPassword.validateStatus"
          :help="form.confirmNewPassword.help"
          hasFeedback
        >
          <template slot="label">
            <span class="required">确认新密码</span>
          </template>
          <Input
            type="password"
            placeholder="请输入密码"
            v-model="form.confirmNewPassword.value"
            @change="validateHandler('confirmNewPassword', $event)"
          />
          <span
            class="iconTip"
            v-show="
              !form.confirmNewPassword.value &&
              !form.confirmNewPassword.validateStatus
            "
            ><img src="../../assets/images/icon-tip.jpg" /><span>{{
              this.pwdValidMsg
            }}</span></span
          >
        </a-form-item>
        <a-form-item
          class="form-item"
          v-bind="formItemLayout"
          :validate-status="form.codeImg.validateStatus"
          :help="form.codeImg.help"
          hasFeedback
        >
          <template slot="label">
            <span class="required">请输入验证码</span>
          </template>
          <Input
            type="text"
            placeholder="请输入验证码"
            v-model="form.codeImg.value"
            @change="validateHandler('codeImg', $event)"
          />
          <span class="pwdImg" @click="getCodePic">
            <img :src="picCodeSet.src" alt="" class="pwdImg" />
          </span>
        </a-form-item>
        <a-form-item class="form-item" label=" " v-bind="formItemLayout">
          <Button
            class="op-btn"
            type="primary"
            @click.native="save"
            :disabled="isDisabled"
            >保存</Button
          >
          <Button class="op-btn" @click="back">返回</Button>
        </a-form-item>
      </a-form>
    </pop-panel>
  </CommonFramework>
</template>

<script>
import CommonFramework from "../../shared/components/lyCommonFramework";
import { Input, Button } from "ant-design-vue";
import queryString from "query-string";
import { Base64 } from "js-base64";
import PopPanel from "@components/popPanel/index";
import form from "@utils/form";
import vuexMapper from "@mixins";
import { http, util, $http } from "@utils";
import host from "@utils/api";
import CONSTANT from "@utils/constant";
import appConst from "@utils/constant";
import api from "@utils/api";

export default {
  name: "auth-change-password",
  components: { PopPanel, Input, Button, CommonFramework },
  mixins: [form, vuexMapper],
  data() {
    return {
      pwdValidMsg: this.$store.state.securityConfig.pwdValidMsg,
      codeNumber: {
        identity: "",
        appCode: "",
        appServiceCode: "",
      },
      picCodeSet: {
        src: "",
      },
      form: {
        originalPassword: {
          value: "",
          validateStatus: "",
          help: "  ",
        },
        newPassword: {
          value: "",
          validateStatus: "",
          help: "",
        },
        confirmNewPassword: {
          value: "",
          validateStatus: "",
          help: "",
        },
        codeImg: {
          validateStatus: "",
          value: "",
          help: "",
        },
      },
    };
  },
  mounted() {
    util.$tracker(157, "288924", 10000);
    this.getCodePic();
  },
  methods: {
    async modifyPwd(param) {
      const { code, msg } = await $http.post(
        `${host.mainHost}${host.mainContentPath}/account/modifyPwd.do`,
        queryString.stringify({ param }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      if (code === "1") {
        this.$message.success("修改成功！");
        this.$router.push({
          name: "lylogin",
        });
      } else {
        this.getCodePic();
        this.$message.error(msg);
      }
    },
    async getCodePic() {
      const uuidV4 = require("uuid/v4");

      this.codeNumber.identity = Base64.encode(
        `${this.$route.query.account}_${uuidV4()}`
      );
      this.codeNumber.appCode = Base64.encode(`${appConst.APPCODE}`);
      this.codeNumber.appServiceCode = Base64.encode(
        `${appConst.APP_SERVICE_CODE}`
      );
      const query = queryString.stringify(this.codeNumber);
      this.picCodeSet.src = `${api.verifycodeHost}/ucode-web/ucode/getNumber.do?${query}`;
    },
    async save() {
      if (
        await this.validateFields([
          "originalPassword",
          "newPassword",
          "confirmNewPassword",
          "codeImg",
        ])
      ) {
        const { form } = this;
        const { originalPassword, newPassword, confirmNewPassword, codeImg } =
          form;
        const params = {
          loginName: this.$route.query.account,
          oldPassword: originalPassword.value,
          password: newPassword.value,
          pwdConfirm: confirmNewPassword.value,
          vCode: codeImg.value,
          appCode: this.codeNumber.appCode,
          identity: this.codeNumber.identity,
          appServiceCode: this.codeNumber.appServiceCode,
        };
        this.modifyPwd(JSON.stringify(params));
      }
    },
  },
};
</script>
<style lang="scss" src="./index.scss" scoped></style>
